import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

// The admin area loads in its own chunk: nobody but admins needs it (spec 011).
const AdminPage = lazy(() => import('../components/admin/AdminPage.js'))

export const Route = createFileRoute('/admin')({
  component: () => (
    <Suspense fallback={null}>
      <AdminPage />
    </Suspense>
  ),
})
